import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
const FAQS = [{
  question: '¿Necesito saber de tecnología para entender este contenido?',
  answer: 'No. Esta guía fue creada exactamente para personas que no tienen conocimientos técnicos. Todo está explicado con lenguaje simple, pasos claros y ejemplos del día a día.'
}, {
  question: '¿Sirve para cualquier modelo de iPhone?',
  answer: 'Sí. El contenido aplica para la gran mayoría de modelos de iPhone con iOS actual. Ya tengas un iPhone más reciente o uno de hace algunos años, vas a encontrar información útil y aplicable.'
}, {
  question: '¿También sirve si vengo de Android?',
  answer: 'Sí, especialmente para ti. Si cambiaste de Android y todavía no entiendes bien cómo funciona iOS, esta guía te va a ayudar a entender la lógica del iPhone desde el principio.'
}, {
  question: '¿El contenido es difícil de aplicar?',
  answer: 'No. Cada sección está diseñada para que puedas aplicar lo que aprendes de forma inmediata. No necesitas ser experto, no necesitas herramientas externas y no necesitas mucho tiempo.'
}, {
  question: '¿Recibo acceso inmediato después de comprar?',
  answer: 'Sí. Una vez que completas tu compra, recibes acceso inmediato al contenido por mail para que puedas empezar hoy mismo.'
}, {
  question: '¿Puedo verlo desde mi iPhone?',
  answer: 'Sí. Puedes acceder al contenido desde tu iPhone, iPad, computadora o cualquier dispositivo con acceso a internet.'
}, {
  question: '¿Incluye trucos de cámara, seguridad y organización?',
  answer: 'Sí. El libro principal cubre todo eso, y además recibes 5 bonos adicionales que profundizan en configuración, seguridad, organización, trucos ocultos y cámara.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tienes una garantía de satisfacción de 10 días. Si el contenido no cumple tus expectativas, puedes solicitar tu devolución dentro de los 10 días desde tu compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-cream-100" data-id="element-120" data-mp="2kvn74p3mr9wl">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-deep" data-id="element-121" data-mp="2kuluwhavohda">Preguntas frecuentes</p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-ink-950 sm:text-4xl" data-id="element-122" data-mp="2fur0w4vt3bo0">Antes de que decidas</h2>
      <div className="mt-10 space-y-3" data-id="element-123" data-mp="38l94d70fzf1y">
        {FAQS.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-2xl border border-ink-950/10 bg-white" data-id="element-124" data-mp="33mxw30pspclu" data-mpi={index}>
              <h3 data-id="element-125" data-mp="2ylibf9rj583z">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-sm font-semibold text-ink-950 transition-colors hover:bg-cream-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent sm:px-7 sm:text-base" data-id="element-126" data-mp="2yp65ca0vzwj8">
                  {faq.question}
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent/10" data-id="element-127" data-mp="2qdoke025xtb">
                    <PlusIcon className="h-4 w-4 text-accent-deep" aria-hidden="true" data-id="element-128" data-mp="hdyqi4l75qzn" />
                  </motion.span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-129" data-mp="qfosu5gmaac7">
                {isOpen ? <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-130" data-mp="qdlsoslr30tr">
                    <p className="px-5 pb-6 text-sm leading-relaxed text-ink-800/80 sm:px-7 sm:text-base" data-id="element-131" data-mp="2x88snszmpmxi">{faq.answer}</p>
                  </motion.div> : null}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}